// Logo URLs
export const LOGO_HORIZONTAL = "https://customer-assets.emergentagent.com/job_vision-care-build/artifacts/qh6mor8s_%D0%92%D0%B0%D1%88_%D0%97%D1%96%D1%80_LOGO_new%20orange.png";
export const LOGO_SQUARE = "/logo-square.png";

// Images
export const IMAGES = {
  hero: "https://images.pexels.com/photos/5752232/pexels-photo-5752232.jpeg?auto=compress&cs=tinysrgb&w=1920",
  equipment1: "https://images.pexels.com/photos/5752262/pexels-photo-5752262.jpeg?auto=compress&cs=tinysrgb&w=800",
  equipment2: "https://images.pexels.com/photos/5752302/pexels-photo-5752302.jpeg?auto=compress&cs=tinysrgb&w=800",
  equipment3: "https://images.pexels.com/photos/5752242/pexels-photo-5752242.jpeg?auto=compress&cs=tinysrgb&w=800",
  consultation: "https://images.pexels.com/photos/7578808/pexels-photo-7578808.jpeg?auto=compress&cs=tinysrgb&w=800",
  clinic: "https://images.pexels.com/photos/6048561/pexels-photo-6048561.jpeg?auto=compress&cs=tinysrgb&w=800",
};

// Doctors
export const DOCTORS = [
  {
    id: "baryska",
    name: "Бариська Оксана Богданівна",
    role: "Завідувачка діагностичним відділенням. Лікар вищої категорії",
    specialization: "Діагностика",
    experience: 29,
    photo: "/doctors/baryska-900w.webp",
    photoSm: "/doctors/baryska-480w.webp",
    photoFallback: "/doctors/baryska-900w.jpg",
    description: "Завідувачка діагностичним відділенням. Лікар вищої категорії.",
  },
  {
    id: "zamiatin",
    name: "Замятін Віктор Львович",
    role: "Лікар-терапевт вищої категорії",
    specialization: "Терапія",
    experience: 33,
    photo: "/doctors/zamiatin-900w.webp",
    photoSm: "/doctors/zamiatin-480w.webp",
    photoFallback: "/doctors/zamiatin-900w.jpg",
    description: "Лікар-терапевт вищої категорії.",
  },
  {
    id: "karliichuk",
    name: "Карлійчук Марина Аксентіївна",
    role: "Завідувачка відділенням вітреоретинальної та лазерної мікрохірургії ока. Доктор медичних наук. Професор. Лікар вищої категорії",
    specialization: "Сітківка",
    experience: 29,
    photo: "/doctors/karliichuk-900w.webp",
    photoSm: "/doctors/karliichuk-480w.webp",
    photoFallback: "/doctors/karliichuk-900w.jpg",
    description: "Завідувачка відділенням вітреоретинальної та лазерної мікрохірургії ока. Доктор медичних наук. Професор. Лікар вищої категорії.",
  },
  {
    id: "kirbaba",
    name: "Кірбаба Ірина Володимирівна",
    role: "Завідувачка відділенням дитячої офтальмології. Лікар вищої категорії",
    specialization: "Дитяча офтальмологія",
    experience: 35,
    photo: "/doctors/kirbaba-900w.webp",
    photoSm: "/doctors/kirbaba-480w.webp",
    photoFallback: "/doctors/kirbaba-900w.jpg",
    description: "Завідувачка відділенням дитячої офтальмології. Лікар вищої категорії.",
  },
  {
    id: "lukiian",
    name: "Лукіян Андрій Іванович",
    role: "Лікар першої категорії",
    specialization: "Офтальмологія",
    experience: 16,
    photo: "/doctors/lukiian-900w.webp",
    photoSm: "/doctors/lukiian-480w.webp",
    photoFallback: "/doctors/lukiian-900w.jpg",
    description: "Лікар першої категорії.",
  },
  {
    id: "pinchuk",
    name: "Пінчук Сергій Віталійович",
    role: "Завідувач відділенням катаракти та глаукоми. Кандидат медичних наук. Лікар вищої категорії",
    specialization: "Хірургія",
    experience: 29,
    photo: "/doctors/pinchuk-900w.webp",
    photoSm: "/doctors/pinchuk-480w.webp",
    photoFallback: "/doctors/pinchuk-900w.jpg",
    description: "Завідувач відділенням катаракти та глаукоми. Кандидат медичних наук. Лікар вищої категорії.",
  },
  {
    id: "urazov",
    name: "Уразов Артем Жараспайович",
    role: "Провідний хірург відділення вітреоретинальної та лазерної мікрохірургії ока",
    specialization: "Сітківка",
    experience: 23,
    photo: "/doctors/urazov-900w.webp",
    photoSm: "/doctors/urazov-480w.webp",
    photoFallback: "/doctors/urazov-900w.jpg",
    description: "Провідний хірург відділення вітреоретинальної та лазерної мікрохірургії ока.",
  },
  {
    id: "shyroka",
    name: "Широка Ольга Іванівна",
    role: "Лікар другої категорії",
    specialization: "Офтальмологія",
    experience: 12,
    photo: "/doctors/shyroka-900w.webp",
    photoSm: "/doctors/shyroka-480w.webp",
    photoFallback: "/doctors/shyroka-900w.jpg",
    description: "Лікар другої категорії.",
  },
];

// Services
export const SERVICES = [
  {
    id: "diagnostyka",
    slug: "diagnostyka",
    title: "Діагностика зору",
    shortDesc: "Новітні методи досліджень, єдині в регіоні, повернуть вам радість та барви життя.",
    fullDesc: "Зробіть перший крок до Вашого Зору! Центр мікрохірургії ока «Ваш зір» пропонує повний комплекс діагностики зору з використанням найсучаснішого обладнання, єдиного в регіоні.",
    icon: "Eye",
    heroImage: "https://images.pexels.com/photos/5752262/pexels-photo-5752262.jpeg?auto=compress&cs=tinysrgb&w=1200",
    benefits: [
      "Повна діагностика за один візит",
      "Обладнання світового рівня",
      "Єдині в регіоні методи дослідження",
      "Точний діагноз та план лікування",
    ],
    steps: [
      { title: "Запис на прийом", desc: "Зателефонуйте або заповніть форму на сайті" },
      { title: "Первинна консультація", desc: "Лікар проведе огляд та визначить необхідні дослідження" },
      { title: "Комплексна діагностика", desc: "Проведення всіх необхідних досліджень на сучасному обладнанні" },
      { title: "Результат та план", desc: "Детальне пояснення результатів та рекомендації щодо лікування" },
    ],
    doctors: ["baryska", "lukiian", "shyroka"],
    faq: [
      { q: "Скільки часу займає повна діагностика?", a: "Комплексна діагностика зору займає від 1 до 2 годин залежно від необхідних досліджень." },
      { q: "Чи потрібна спеціальна підготовка?", a: "Спеціальної підготовки не потрібно. Рекомендуємо не носити контактні лінзи за 2 дні до обстеження." },
      { q: "Як часто потрібно проходити діагностику?", a: "Рекомендовано проходити повну діагностику зору щорічно після 40 років та кожні 2 роки для молодших пацієнтів." },
    ],
  },
  {
    id: "katarakta",
    slug: "katarakta",
    title: "Лікування катаракти та глаукоми",
    shortDesc: "Повертайтесь до повноцінного життя безболісно, усього за кілька хвилин.",
    fullDesc: "Не піддавайтесь страху та не зволікайте із лікуванням. Катаракти можна повністю позбутися безболісно та усього за кілька хвилин, а розвиток глаукоми — зупинити.",
    icon: "Sparkles",
    heroImage: "https://images.pexels.com/photos/5752232/pexels-photo-5752232.jpeg?auto=compress&cs=tinysrgb&w=1200",
    benefits: [
      "Безболісна операція за 15-20 хвилин",
      "Більше 60 000 успішних операцій",
      "Найсучасніші інтраокулярні лінзи",
      "Швидке відновлення зору",
    ],
    steps: [
      { title: "Діагностика", desc: "Повне обстеження ока та підбір оптимальної лінзи" },
      { title: "Підготовка", desc: "Лікар пояснить процедуру та відповість на всі питання" },
      { title: "Операція", desc: "Факоемульсифікація через мікророзріз — 15-20 хвилин" },
      { title: "Відновлення", desc: "Зір покращується вже наступного дня, повне відновлення за тиждень" },
    ],
    doctors: ["pinchuk"],
    faq: [
      { q: "Чи боляче робити операцію з катаракти?", a: "Ні, операція абсолютно безболісна. Проводиться під місцевою краплинною анестезією." },
      { q: "Скільки часу займає відновлення?", a: "Зір значно покращується вже на наступний день. Повне відновлення — протягом 1-2 тижнів." },
      { q: "В якому віці можна робити операцію?", a: "Операція можлива в будь-якому віці. Не варто зволікати — чим раніше, тим краще результат." },
    ],
  },
  {
    id: "kids",
    slug: "kids",
    title: "Дитяча офтальмологія",
    shortDesc: "Лікування в ігровій формі на спеціалізованому обладнанні для дітей.",
    fullDesc: "Поганий зір не повинен заважати розвитку дитини. Ми допоможемо зупинити розвиток короткозорості, далекозорості та косоокості.",
    icon: "Baby",
    heroImage: "https://images.pexels.com/photos/7578808/pexels-photo-7578808.jpeg?auto=compress&cs=tinysrgb&w=1200",
    benefits: [
      "Обстеження в ігровій формі",
      "Спеціалізоване дитяче обладнання",
      "Досвідчені дитячі офтальмологи",
      "Апаратне лікування без операцій",
    ],
    steps: [
      { title: "Запис", desc: "Запишіть дитину на прийом за телефоном або онлайн" },
      { title: "Знайомство", desc: "Лікар знайомиться з дитиною в ігровій формі" },
      { title: "Обстеження", desc: "Повна діагностика зору на дитячому обладнанні" },
      { title: "Лікування", desc: "Апаратне лікування або рекомендації щодо корекції" },
    ],
    doctors: ["kirbaba"],
    faq: [
      { q: "З якого віку можна обстежувати дитину?", a: "Перший огляд рекомендований вже з 6 місяців. Повна діагностика можлива з 3 років." },
      { q: "Дитина боїться лікарів. Як проходить огляд?", a: "Наші спеціалісти працюють з дітьми в ігровій формі. Обладнання адаптоване для маленьких пацієнтів." },
    ],
  },
  {
    id: "presbyopia",
    slug: "presbyopia",
    title: "Лікування пресбіопії",
    shortDesc: "Стань кращою версією себе — без окулярів та лінз.",
    fullDesc: "Із віком зір погіршується на близькій відстані і з'являються кілька пар окулярів. Позбавтесь їх та поверніть собі якісний зір за допомогою сучасних технологій.",
    icon: "Glasses",
    heroImage: "https://images.pexels.com/photos/6048561/pexels-photo-6048561.jpeg?auto=compress&cs=tinysrgb&w=1200",
    benefits: [
      "Позбавлення від окулярів для читання",
      "Сучасні мультифокальні лінзи",
      "Швидке відновлення",
      "Покращення якості життя",
    ],
    steps: [
      { title: "Консультація", desc: "Визначення ступеня пресбіопії та підбір методу лікування" },
      { title: "Підготовка", desc: "Детальне пояснення процедури та очікуваних результатів" },
      { title: "Процедура", desc: "Імплантація мультифокальної лінзи — безболісно, швидко" },
      { title: "Результат", desc: "Чіткий зір на всіх відстанях без окулярів" },
    ],
    doctors: ["pinchuk"],
    faq: [
      { q: "Що таке пресбіопія?", a: "Пресбіопія — вікова далекозоркість, при якій погіршується зір на близькій відстані. Починається зазвичай після 40 років." },
      { q: "Чи можна повністю позбутися окулярів?", a: "У більшості випадків — так. Сучасні мультифокальні лінзи забезпечують чіткий зір на всіх відстанях." },
    ],
  },
  {
    id: "sitkivka",
    slug: "sitkivka",
    title: "Лікування захворювань сітківки",
    shortDesc: "Єдині в регіоні проводимо повний комплекс діагностики та лікування сітківки.",
    fullDesc: "Цукровий діабет, вікові зміни та інше призводять до захворювань сітківки та втрати зору. Не зволікайте із обстеженням — вчасна діагностика збереже Ваш зір.",
    icon: "ScanEye",
    heroImage: "https://images.pexels.com/photos/5752232/pexels-photo-5752232.jpeg?auto=compress&cs=tinysrgb&w=1200",
    benefits: [
      "Єдині в регіоні — повний комплекс лікування",
      "Лазерна коагуляція сітківки",
      "Інтравітреальні ін'єкції",
      "Регулярний моніторинг стану",
    ],
    steps: [
      { title: "Діагностика", desc: "ОКТ, фундус-фотографія, флуоресцентна ангіографія" },
      { title: "Діагноз", desc: "Визначення типу та стадії захворювання сітківки" },
      { title: "Лікування", desc: "Лазерна коагуляція або інтравітреальні ін'єкції" },
      { title: "Спостереження", desc: "Регулярний моніторинг стану сітківки" },
    ],
    doctors: ["karliichuk"],
    faq: [
      { q: "Які захворювання сітківки ви лікуєте?", a: "Діабетична ретинопатія, вікова макулярна дегенерація, відшарування сітківки, тромбоз вен сітківки та інші." },
      { q: "Чи болісне лазерне лікування?", a: "Лазерна коагуляція проводиться під місцевою анестезією і зазвичай не викликає болю." },
    ],
  },
];

// FAQ
export const FAQ_DATA = [
  { category: "Загальні питання", items: [
    { q: "Як записатись на прийом?", a: "Зателефонуйте за номером +38 (050) 543 01 01 або +38 (067) 919 01 01, або заповніть форму запису на сайті. Ми зв'яжемося з вами протягом 30 хвилин." },
    { q: "Яка вартість консультації?", a: "Вартість первинної консультації залежить від обсягу обстеження. Зателефонуйте нам для уточнення." },
    { q: "Які документи потрібні для прийому?", a: "Візьміть з собою паспорт та попередні медичні документи, якщо вони є (результати обстежень, рецепти на окуляри)." },
    { q: "Чи працюєте ви з дітьми?", a: "Так, у нас є спеціалізоване відділення дитячої офтальмології з досвідченими лікарями та дитячим обладнанням." },
  ]},
  { category: "Про операції", items: [
    { q: "Чи безпечні операції в центрі?", a: "Так. За 30 років роботи ми провели понад 60 000 операцій з 100% показником успішності. Використовуємо обладнання світового рівня." },
    { q: "Скільки часу потрібно для відновлення після операції?", a: "Залежить від типу операції. Після факоемульсифікації (катаракта) зір покращується вже наступного дня." },
    { q: "Чи потрібна госпіталізація?", a: "Більшість операцій проводяться амбулаторно — ви зможете повернутися додому того ж дня." },
  ]},
  { category: "Оплата та страхування", items: [
    { q: "Які форми оплати ви приймаєте?", a: "Готівка, банківські картки, безготівковий переказ." },
    { q: "Чи є можливість оплати частинами?", a: "Так, ми пропонуємо можливість оплати частинами для деяких видів лікування. Уточнюйте на рецепції." },
  ]},
];

// Self-test questions
export const SELF_TEST_QUESTIONS = [
  {
    question: "Чи помічаєте ви затуманення зору?",
    options: ["Так, часто", "Іноді", "Ні"],
    weights: [3, 1, 0],
  },
  {
    question: "Чи відчуваєте різь, сухість або печіння в очах?",
    options: ["Так, регулярно", "Іноді", "Ні"],
    weights: [3, 1, 0],
  },
  {
    question: "Чи важко вам читати дрібний текст або працювати за комп'ютером?",
    options: ["Так", "Трохи", "Ні, все добре"],
    weights: [3, 1, 0],
  },
  {
    question: "Коли ви востаннє відвідували офтальмолога?",
    options: ["Більше 2 років тому", "Протягом останнього року", "Менше 6 місяців тому"],
    weights: [3, 1, 0],
  },
  {
    question: "Чи є у вашій родині випадки глаукоми, катаракти або інших захворювань ока?",
    options: ["Так", "Не впевнений(а)", "Ні"],
    weights: [3, 1, 0],
  },
];

// Contact info
export const CONTACT = {
  address: "Україна, м. Чернівці, вул. Вокзальна, 21 Б",
  phone1: "+38 (050) 543 01 01",
  phone2: "+38 (067) 919 01 01",
  phone3: "+38 (0372) 58 33 33",
  phone1Link: "tel:+380505430101",
  phone2Link: "tel:+380679190101",
  phone3Link: "tel:+380372583333",
  mapUrl: "https://www.google.com/maps?q=%D0%A7%D0%B5%D1%80%D0%BD%D1%96%D0%B2%D1%86%D1%96%2C+%D0%B2%D1%83%D0%BB.+%D0%93%D0%B0%D0%B3%D0%B0%D1%80%D1%96%D0%BD%D0%B0%2C+21%D0%91&hl=uk&z=17&output=embed",
  workHours: "Пн-Пт: 09:00 - 17:00",
  viber: "viber://chat?number=380505430101",
  telegram: "https://t.me/+380505430101",
  whatsapp: "https://wa.me/380505430101",
};

// Advantages
export const ADVANTAGES = [
  { title: "Найкращі в регіоні", desc: "100% дотримання передових методик лікування та найякісніших операційних розхідних матеріалів", icon: "Award" },
  { title: "Обладнання світового рівня", desc: "Найсучасніше обладнання від провідних світових виробників", icon: "Cpu" },
  { title: "Досвідчені лікарі", desc: "Понад 30 років практики, більше 60 000 успішних операцій", icon: "Users" },
  { title: "Гарантія якості", desc: "100% якість операційних розхідних матеріалів та методик лікування", icon: "ShieldCheck" },
];

// Counters
export const COUNTERS = [
  { value: 30, suffix: "+", label: "Років досвіду" },
  { value: 60000, suffix: "+", label: "Операцій" },
  { value: 1000000, suffix: "+", label: "Обстежень" },
  { value: 97, suffix: "%", label: "Задоволених пацієнтів" },
];

// Google Business Reviews
export const GOOGLE_REVIEWS = [
  {
    id: "olesia-kaptar",
    name: "Olesia Kaptar",
    initial: "O",
    avatarColor: "#E8590A",
    meta: "2 відгуки • 0 фотографій",
    rating: 5,
    timeAgo: "5 тижнів тому",
    text: "В клініці «Ваш зір» моїй мамі зробили операцію на катаракту і поклали кришталик. Ми дуже задоволені як все пройшло. Мама зараз бачить прекрасно! Плануємо і на інше око провести таку операцію. Досвідчені спеціалісти, все дуже гарно організовано, медичний персонал дуже приємний, ціни доступні. Однозначно раджу всім клініку «Ваш зір»! Щиро вдячна за прекрасну роботу.",
  },
  {
    id: "vladimir-havresh",
    name: "Володимир Гавреш",
    initial: "В",
    avatarColor: "#4C6EF5",
    meta: "2 відгуки • 1 фотографія",
    rating: 5,
    timeAgo: "9 тижнів тому",
    text: "Сучасна клініка, з високим рівнем спеціалістів. Всі послуги, які мені надавались, супроводжувались уважним відношенням компетентних медиків. Відчувається, що власники люблять свою справу, та дбайливо відносяться до пацієнтів. Рекомендую потребуючим, адже тут є сучасне обладнання та високий рівень робіт та сервісу.",
  },
  {
    id: "olena-avdeichyk",
    name: "Олена Авдейчик",
    initial: "О",
    avatarColor: "#F783AC",
    meta: "Місцевий експерт • 8 відгуків • 27 фотографій",
    rating: 5,
    timeAgo: "11 тижнів тому",
    text: "В клініці «Ваш зір» робили операцію з видалення катаракти моєму дяді. Величезне дякую персоналу. Доброзичливі, чуйні та турботливі люди, окружили дядька максимальною увагою та підтримкою. Умови перебування суперкомфортні. Результатом задоволені!",
  },
  {
    id: "vasia-liashenko",
    name: "Вася Ляшенко",
    initial: "В",
    avatarColor: "#845EF7",
    meta: "1 відгук • 0 фотографій",
    rating: 5,
    timeAgo: "13 тижнів тому",
    text: "Хочу щиро подякувати офтальмологічній клініці за професіоналізм та людяне ставлення до військових. Проходив безоплатний огляд — залишився дуже задоволений. Лікарі уважні, ввічливі і дійсно зацікавлені допомогти. Провели якісне обстеження, все детально пояснили та підібрали чудове лікування. Відчувається турбота, підтримка і високий рівень професіоналізму. Щиро рекомендую цю клініку та дякую всьому персоналу за вашу працю і повагу до військових!",
  },
  {
    id: "vitaly-s",
    name: "Vitaly S",
    initial: "V",
    avatarColor: "#F59F00",
    meta: "Місцевий експерт • 12 відгуків • 14 фотографій",
    rating: 5,
    timeAgo: "13 тижнів тому",
    text: "Вже два роки лікуюся в офтальмологічній клініці «Ваш зір» і безмежно задоволений результатами! Низький уклін завідуючій відділенням лікування сітківки Карлійчук Марині Аксентіївні та завідуючій діагностичним відділенням Бариській Оксані Богданівні за їхній професіоналізм, турботу та золоті руки. Також дякую всьому персоналу за чуйне ставлення та чудову атмосферу. Ви повертаєте людям радість бачити світ! Рекомендую клініку кожному!",
  },
  {
    id: "yakubovska-ariadna",
    name: "Якубовська Аріадна",
    initial: "Я",
    avatarColor: "#94D82D",
    meta: "5 відгуків • 0 фотографій",
    rating: 5,
    timeAgo: "35 тижнів тому",
    text: "Були з дитиною на апаратному лікуванні в клініці «Ваш Зір», Кірбаба Ірина Володимирівна — дуже досвідчений дитячий офтальмолог. В клініки активна соціальна позиція: з нами разом проходила обстеження дитина військового, обстеження для дітей УБД безкоштовне, а лікувальні управи по пільговій ціні. Загалом все сподобалось, персонал привітний, буду всім рекомендувати!!!!",
  },
  {
    id: "katia",
    name: "Катя",
    initial: "К",
    avatarColor: "#495057",
    meta: "3 відгуки • 0 фотографій",
    rating: 5,
    timeAgo: "6 тижнів тому",
    text: "Хочу щиро подякувати колективу «Ваш Зір». Я переселенка і лікуюся у вашому центрі з 2022 року. За цей час завжди відчувала турботу, людяність і уважне ставлення. Окрема подяка моєму лікарю — Оксані Богданівні. Це справжній професіонал своєї справи, дуже уважна, доброзичлива та чуйна людина. Вона завжди все пояснює, підтримує і ставиться до пацієнтів з повагою та щирою турботою. Вважаю, що це спеціаліст від Бога. Щиро дякую за вашу працю, професіоналізм і добре серце. Бажаю всьому колективу здоров'я, миру та вдячних пацієнтів!",
  },
];

// Direct link to the clinic's Google Business profile reviews
export const GOOGLE_REVIEWS_URL = "https://www.google.com/maps/place/%D0%92%D0%B0%D1%88+%D0%97%D1%96%D1%80/@48.2884,25.9204,17z/data=!4m8!3m7!1s0x0:0x0!8m2!3d48.2884!4d25.9204!9m1!1b1";
